// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton--RvjtL"};